import React, { useState } from "react";
import "./SearchForm.css";

export default function SearchForm(props) {
  let [keyword, setKeyword] = useState("");

  function handleSubmit(event) {
    event.preventDefault();
    props.onSearch(keyword);
  }

  function updateKeyword(event) {
    setKeyword(event.target.value);
  }

  return (
    <form onSubmit={handleSubmit} className="SearchForm">
      <input
        type="search"
        placeholder="Search"
        onChange={updateKeyword}
        className="SearchForm-input"
      />
      <input type="submit" value="Search" className="SearchForm-button" />
    </form>
  );
}
